// INITS

const productVariantABtest = document.querySelector(".product_variant_abtest");

function launchSriptProductVariantB() {
  const productVariantItems = document.querySelectorAll(".variant_item");
  const inputProductForm = document.querySelector("#form-id");
  const productPrice = document.querySelector("#product_total_price");

  const productPriceSticky = document.querySelector(".sticky-atc .dualPrice");

  const productQuantityInput = document.querySelector(
    ".product-quantity__input"
  );
  const btnProductQuantityMoins = document.querySelector(
    "#product_quantity_moins"
  );
  const btnProductQuantityPlus = document.querySelector(
    "#product_quantity_plus"
  );

  let productPriceSelected = productVariantItems[0].dataset.price;

  let productPriceDisplayed;

  let productQuantitySelected = 1;

  // FUNCTIONS

  function financial(x) {
    let goToDecimal = x / 100;
    return Number.parseFloat(goToDecimal).toFixed(2).replace(".", ",");
  }

  function updateProductQuantity() {
    productPriceDisplayed = financial(
      productPriceSelected * productQuantitySelected
    );
    productPrice.innerHTML = `${productPriceDisplayed}€`;
    document.querySelector('.sticky-atc [name="id"]').value = document.querySelector('.variant_item.active').dataset.value;
    document.querySelector('.sticky-atc .product-form__price').innerHTML =  `${productPriceDisplayed}€`;

  }

  // ITEM SELECTOR

  productVariantItems[0].addEventListener("click", (e) => {
    productVariantItems[1].classList.remove("active");
    productVariantItems[0].classList.add("active");

    inputProductForm.value = productVariantItems[0].dataset.value;

    productPriceSelected = productVariantItems[0].dataset.price;
    updateProductQuantity();
  });

  productVariantItems[1].addEventListener("click", (e) => {
    productVariantItems[0].classList.remove("active");
    productVariantItems[1].classList.add("active");

    inputProductForm.value = productVariantItems[1].dataset.value;
    productPriceSelected = productVariantItems[1].dataset.price;
    updateProductQuantity();
  });

  //-------------------

  // BUTTON QUANTITY

  btnProductQuantityMoins.addEventListener("click", (e) => {
    if (productQuantitySelected != 1) {
      productQuantitySelected--;
      updateProductQuantity();
    }
  });

  btnProductQuantityPlus.addEventListener("click", (e) => {
    if (productQuantitySelected < 21) {
      productQuantitySelected++;
      updateProductQuantity();
    }
  });
}

if (productVariantABtest.hasAttribute("id")) {
  launchSriptProductVariantB();
}

/*

let countCheckProductVariantID = 1;

function checkProductVariantID(){

    if(productVariantABtest.hasAttribute('id')){
        launchSriptProductVariantB();
        clearInterval(timerCheckProductVariantID);
    }

    console.log(countCheckProductVariantID);
    countCheckProductVariantID++;


    if(countCheckProductVariantID == 5){
        clearInterval(timerCheckProductVariantID);
    }

};

let timerCheckProductVariantID = setInterval(checkProductVariantID, 1000);

*/

// INITS

/*

const btnTotalPrice = document.querySelector('#product_total_price');

let idProductVariantSelected = productVariantItems[0].dataset.value;
let priceProductVariantSelected = financial(productVariantItems[0].dataset.price);
let productTotalPrice = priceProductVariantSelected;

*/

// FUNCTIONS

/*

function updateProductTotalPrice(){
    productTotalPrice = priceProductVariantSelected * productQuantitySelected;
    btnTotalPrice.innerHTML = `${productTotalPrice}€`
}
updateProductTotalPrice();

function updateProductQuantity(){

    if(productQuantitySelected == 1){
        btnProductQuantityMoins.setAttribute('disabled','');
    }else if(productQuantitySelected == 20){
        btnProductQuantityMoins.removeAttribute('disabled');
        btnProductQuantityPlus.setAttribute('disabled','');
    }else{
        btnProductQuantityMoins.removeAttribute('disabled');
        btnProductQuantityPlus.removeAttribute('disabled');
    }

    productQuantityInput.setAttribute('value', productQuantitySelected)
    productQuantityInput.innerHTML = `${productQuantityInput.value}`;

    updateProductTotalPrice();
}
updateProductQuantity();

*/

// BUTTON QUANTITY

/*


btnProductQuantityMoins.addEventListener('click', (e) => {
    if(productQuantitySelected != 1){
        productQuantitySelected--;
        updateProductQuantity();
    }
})

btnProductQuantityPlus.addEventListener('click', (e) => {
    if(productQuantitySelected < 21){
        productQuantitySelected++;
        updateProductQuantity();
    }
})

// BUTTON ADD TO CART

const mainBtnProductATC = document.querySelector('#main_product_add_to_cart');

mainBtnProductATC.addEventListener('click', (e) => {
    productAddToCart(idProductVariantSelected,productQuantitySelected);
    openCartDrawer();
});

*/

// TIMER CHECK VARIANT ID
